var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { WebPlugin } from '@capacitor/core';
//#endregion Google Pay Web Api
//#region Web Script loader
/**
 * Загрузит необходимый скрипт для Google Pay
 */
export function googlePayLoader() {
    return new Promise((resolve, reject) => {
        const src = 'https://pay.google.com/gp/p/js/pay.js';
        const script = document.createElement('script');
        script.setAttribute('src', src);
        script.setAttribute('async', '');
        script.setAttribute('defer', '');
        script.onload = () => resolve();
        script.onerror = reject;
        document.head.appendChild(script);
    });
}
let PaymentsClientRef = null;
/**
 * Вернет класс PaymentsClient для работы с оплатой
 */
export function getPaymentsClient() {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        if (PaymentsClientRef)
            return PaymentsClientRef;
        yield googlePayLoader();
        if ((_b = (_a = google === null || google === void 0 ? void 0 : google.payments) === null || _a === void 0 ? void 0 : _a.api) === null || _b === void 0 ? void 0 : _b.PaymentsClient) {
            PaymentsClientRef = google.payments.api.PaymentsClient;
        }
        else {
            throw new Error('Не удалось загрузить GooglePay PaymentsClient');
        }
        return PaymentsClientRef;
    });
}
//#endregion Web Script loader
export class GPayNativeWeb extends WebPlugin {
    constructor() {
        super({
            name: 'GPayNative',
            platforms: ['web'],
        });
        this.paymentsClient = null;
    }
    createClient(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const PaymentsClient = yield getPaymentsClient();
            this.paymentsClient = new PaymentsClient({
                environment: options.test ? 'TEST' : 'PRODUCTION'
            });
        });
    }
    isReadyToPay(request) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.paymentsClient) {
                throw new Error('Не создан объект типа PaymentsClient');
            }
            const { result } = yield this.paymentsClient.isReadyToPay(request);
            return { isReady: result };
        });
    }
    loadPaymentData(request) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.paymentsClient) {
                throw new Error('Не создан объект типа PaymentsClient');
            }
            try {
                return yield this.paymentsClient.loadPaymentData(request);
            }
            catch (e) {
                // Для обеспечения совместимости с нативной логикой Android
                if ((e === null || e === void 0 ? void 0 : e.statusCode) === 'CANCELED') {
                    throw new Error('canceled');
                }
                throw e;
            }
        });
    }
}
const GPayNative = new GPayNativeWeb();
export { GPayNative };
import { registerWebPlugin } from '@capacitor/core';
registerWebPlugin(GPayNative);
//# sourceMappingURL=web.js.map